import React from 'react';

import type { FC } from 'react';

export const LocationOn: FC<React.SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
      <path d="M8.0013 1.44141C5.2013 1.44141 2.66797 3.58807 2.66797 6.90807C2.66797 9.02807 4.3013 11.5214 7.5613 14.3947C7.81464 14.6147 8.19463 14.6147 8.44797 14.3947C11.7013 11.5214 13.3346 9.02807 13.3346 6.90807C13.3346 3.58807 10.8013 1.44141 8.0013 1.44141ZM8.0013 8.10807C7.26797 8.10807 6.66797 7.50807 6.66797 6.77474C6.66797 6.04141 7.26797 5.44141 8.0013 5.44141C8.73463 5.44141 9.33463 6.04141 9.33463 6.77474C9.33463 7.50807 8.73463 8.10807 8.0013 8.10807Z" />
    </svg>
  );
};
